/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import databricksLogo from '@/assets/databricks.png'
import azureDataLakeLogo from '@/assets/msft/Azure-Data-Lake-Gen2-Logo-Large.svg'
import bigQueryLogo from '@/assets/gcp/BigQuery.png'
import awsS3Logo from '@/assets/aws/Arch_Amazon-S3-on-Outposts_64@5x.png'

function DatalakeNode({ data, isConnectable }) {
  const datalakeLogo = () => {
    const demoEnv = localStorage.getItem('TARGET')
    console.log('Target : ', demoEnv)
    if (demoEnv === 'MSFT') {
      return azureDataLakeLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'AWS') {
      return awsS3Logo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else if (demoEnv === 'GCP') {
      return bigQueryLogo
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else {
      return databricksLogo
    }
  }

  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={datalakeLogo()} alt="Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>Datalake</b>
          </div>
        </div>
      </div>

      <Handle type="target" position={Position.Left} />
    </div>
  )
}

export default DatalakeNode
